import { atom } from 'jotai'

import { currentEnv } from '@/env/vars'
import { queryClient } from '@/QueryClient'
import { INewsItem } from '@/types/news'
import { GET } from '@/utils/fetch'

import { store } from '..'

export const isCardVisibleAtom = atom<boolean>(true)
export const showAllAtom = atom(false)
export const newsAtom = atom<INewsItem[]>([])
export const loadingAtom = atom<boolean>(true)
export const selectedNewsAtom = atom<INewsItem>({
    id: '',
    title: '',
    subtitle: '',
    publishDate: '',
    featured: false,
    icon: '',
    image: '',
    article: '',
    introduction: '',
})
export const featuredNewsAtom = atom<INewsItem>({
    id: '',
    title: '',
    subtitle: '',
    publishDate: '',
    featured: true,
    icon: '',
    image: '',
    article: '',
    introduction: '',
})

export const getNews = async (isFeatured: boolean) => {
    store.set(loadingAtom, true)
    const isFeaturedNews = isFeatured ? `?featured=${isFeatured}` : ''
    try {
        const res = await queryClient.fetchQuery({
            queryKey: ['news'],
            queryFn: () => GET<INewsItem[]>(`${currentEnv.utilityUrl}/news${isFeaturedNews}`),
        })
        if (res) {
            if (!isFeatured) {
                store.set(newsAtom, res)
                getNewsById(res[0].id)
            }

            if (isFeatured && res.length > 0) {
                store.set(
                    featuredNewsAtom,
                    res
                        .filter((item) => item.featured)
                        .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())[0],
                )
            }
        }
    } catch (error) {
        console.error('Failed to fetch news:', error)
    } finally {
        store.set(loadingAtom, false)
    }
}

export const getNewsById = async (id: string) => {
    const res = await queryClient.fetchQuery({
        queryKey: ['news'],
        queryFn: () => GET<INewsItem>(`${currentEnv.utilityUrl}/news/${id}`),
    })
    if (res) {
        store.set(selectedNewsAtom, res)
    }
}
